import React, {createRef} from 'react'
import {ListItem} from '@material-ui/core'
import FormatColorTextIcon from '@material-ui/icons/FormatColorText'
import useStyles from './TColorPicker.styles'

const TColorPicker = props => {
  const classes = useStyles()
  const refInput = createRef()

  const handleChangeColor = e => {
    props.onChange(e)
  }
  return (
    <ListItem aria-label="color" className={classes.root} component="label">
      <FormatColorTextIcon style={{color: props.value}} />
      <input
        ref={refInput}
        type="color"
        className={classes.hidden}
        value={`#${props.value}`}
        onChange={handleChangeColor}
      />
    </ListItem>
  )
}

export default TColorPicker
